<template>
  <div :id="`violation-${data.fineOrBonusDeadlineCell.id}`" class="c-table-cell">
    <div class="c-table__cell-value">
      {{ data.fineOrBonusDeadlineCell.deadline }}
    </div>

    <b-popover
      v-if="isFined"
      :target="`violation-${data.fineOrBonusDeadlineCell.id}`"
      triggers="hover blur"
      placement="bottom"
      container="#app"
    >
      Выписан штраф за отсутствие объяснительной в размере 100฿
    </b-popover>
  </div>
</template>

<script>
export default {
  name: "deadline-cell",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isFined() {
      return this.data.fineOrBonusDeadlineCell.deadline === "16.02.2022";
    },
  },
};
</script>

<style lang="scss" scoped>
.c-table__cell-value {
  display: flex;
  flex-direction: column;
  & > a {
    white-space: nowrap;
  }
}
</style>
